import ExpandMore from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material';
import { BikeleasingContractDetailsDTO } from 'probonio-shared-ui/api';
import { useBikeleasingPortalLinkBuilder } from 'probonio-shared-ui/utils/bikeleasingUrl';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ExternalLinkButton } from '../../../component/button/ExternalLinkButton';

export const InspectionSection: React.FC<{ contract: BikeleasingContractDetailsDTO }> = props => {
  const { t } = useTranslation('extensions');
  const { id } = props.contract;
  const buildBikeleasingPortalLink = useBikeleasingPortalLinkBuilder();

  return (
    <Accordion>
      <AccordionSummary
        sx={{ paddingLeft: 1, paddingRight: 0, paddingY: 0 }}
        expandIcon={<ExpandMore sx={{ marginX: 0.5 }} fontSize="large" />}
      >
        <Typography component="span" color="text.secondary" variant="caption">
          {t('bikeleasing_v2.contract.section.inspection')}
        </Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ padding: 0 }}>
        <Typography sx={{ mx: 1, mb: 0.5 }}>{t('bikeleasing_v2.contract.inspectionInfo')}</Typography>
        <ExternalLinkButton
          href={buildBikeleasingPortalLink(`/user/contracts/${id}?SHOW_INSPECTION_PACKAGE=true`)}
          sx={{ mx: 1, mb: 1, mt: 0.5, textAlign: 'center' }}
        >
          {t('bikeleasing_v2.contract.toTheCodes')}
        </ExternalLinkButton>
      </AccordionDetails>
    </Accordion>
  );
};
